import { render, staticRenderFns } from "./AreaConcentracaoForceAtlas2.vue?vue&type=template&id=00bf92ce&scoped=true&"
import script from "./AreaConcentracaoForceAtlas2.vue?vue&type=script&lang=js&"
export * from "./AreaConcentracaoForceAtlas2.vue?vue&type=script&lang=js&"
import style0 from "./AreaConcentracaoForceAtlas2.vue?vue&type=style&index=0&id=00bf92ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf92ce",
  null
  
)

export default component.exports